export default __webpack_public_path__ + "static/media/logo-bw.1605c134.svg";